"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FormatComponent = (function () {
    function FormatComponent() {
        this.componentType = 'format';
    }
    return FormatComponent;
}());
exports.FormatComponent = FormatComponent;
//# sourceMappingURL=format.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-openlayers/dist/components/formats/format.component.js
// module id = 587
// module chunks = 3